export interface Company {
  id: string
  createdAt: string
  updatedAt: string
  name: string
  type?: string
  addressCity?: string
  addressState?: string
  addressStreet?: string
  addressStreet2?: string
  addressZip?: string
  legalName?: string
  logoS3Url?: string
  active?: boolean
  associatedUserCount?: number
  /** Which projects non-invited users may see (installer/developer companies). */
  projectVisibility?: 'ALL' | 'INVITE_ONLY'
  companyOwnership?: any
  subtypeCodes?: CompanySubtypeCode[]
}
export const COMPANY_SUBTYPE_CODES = ['IPP', 'EPC', 'DEV'] as const;
export type CompanySubtypeCode = (typeof COMPANY_SUBTYPE_CODES)[number];

export const COMPANY_SUBTYPE_NAMES: Record<CompanySubtypeCode, string> = {
  IPP: 'Independent Power Producer',
  EPC: 'Engineering, Procurement and Construction',
  DEV: 'Developer'
};

export interface CompanyOwnership {
  companyId: string
  companyName: string
  /** False when the company is deactivated (admin). Omitted in older API responses. */
  companyActive?: boolean
  companyType: string
  id: string
  notes: string
  ownerId: string
  ownerName: string
  solarExperience: string
  thirdPartyExperience: string
  subtypeCodes?: CompanySubtypeCode[]
  /** Latest `user.last_access` among active users for this company (ISO string). */
  lastActivityAt?: string | null
  /** Hash id of the company's investor profile row, when one exists. */
  investorProfileId?: string | null
  /** company_profile_investor.is_visible; null when no investor profile exists. */
  investorIsVisible?: boolean | null
  /** company_profile_investor.full_access; null when no investor profile exists. */
  investorFullAccess?: boolean | null
}


export interface Installer {
  id: string
  companyId: string
  createdAt: string
  updatedAt: string
  company?: Company
}

export interface Investor {
  id: string
  companyId: string
  createdAt: string
  updatedAt: string
  company?: Company
}

export interface PriorInvestor {
  id: string
  name: string
}

export interface ProjectInvestorData {
  id: string
  name: string
  investor: Investor
  parentId: string
  status: string
}